module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image1a"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00iv-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("SIMON & SCHUSTER"), _c('br'), _vm._v("Rockefeller Center"), _c('br'), _vm._v("1230 Avenue of the Americas"), _c('br'), _vm._v("New York, NY 10020"), _c('br')]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("This book is a work of fiction. Names, characters,"), _c('br'), _vm._v("places, and incidents either are products of the"), _c('br'), _vm._v("author’s imagination or are used fictitiously. Any"), _c('br'), _vm._v("resemblance to actual events or locales or persons,"), _c('br'), _vm._v("living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("Copyright © 2004 by Laurie Fox"), _c('br'), _vm._v("All rights reserved,"), _c('br'), _vm._v("including the right of reproduction"), _c('br'), _vm._v("in whole or in part in any form.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IMON")]), _vm._v(" & S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHUSTER")]), _vm._v(" and colophon are registered trademarks"), _c('br'), _vm._v("of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_c('em', [_vm._v("Book design by Ellen R. Sasahara")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("1   3   5   7   9   10   8   6   4   2")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("Fox, Laurie Anne."), _c('br'), _vm._v("The lost girls / Laurie Fox."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("1. Middle aged women—Fiction. 2. San Francisco (Calif.)—Fiction."), _c('br'), _vm._v("3. Peter Pan (Fictitious character)—Fiction. I. Title."), _c('br'), _vm._v("PS3556.O936L67 2004")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("813'.54—dc22                                        2003 059168")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("0-7432-1790-X")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("Permissions:"), _c('br'), _vm._v("Excerpt from “The Breast,” from "), _c('em', [_vm._v("Love Poems,")]), _vm._v(" by Anne Sexton."), _c('br'), _vm._v("Copyright © 1967, 1968, 1969 by Anne Sexton. Reprinted by permission"), _c('br'), _vm._v("of Houghton Mifflin Company. All rights reserved."), _c('br'), _vm._v("Excerpt from "), _c('em', [_vm._v("Love Story,")]), _vm._v(" by Erich Segal. Copyright © 1970 by Erich Segal."), _c('br'), _vm._v("Reprinted by permission of HarperCollins Publishers Inc."), _c('br'), _vm._v("Excerpt from “A Case of You,” by Joni Mitchell. Copyright © 1972 by"), _c('br'), _vm._v("Joni Mitchell Publishing Corp. All rights administered by"), _c('br'), _vm._v("Sony/ATV Publishing, 8 Music Square West, Nashville, TN 37203."), _c('br'), _vm._v("All rights reserved. Used by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightv"
  }, [_vm._v("ISBN-13: 978-0-7432-1790-3"), _c('br'), _vm._v("eISBN-13: 978-0-7432-5357-4")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32210b77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04.vue
// module id = 75
// module chunks = 0